import * as yup from 'yup';

export const commonMovementPatternValidation: { [x: string]: any; } = {
    patternType: yup.string().required("Missing."),
    noOfLift: yup.number().required("Missing.").min(0, "QTY should be range from 0 to 999,999.").max(999999, "QTY should be range from 0 to 999,999."),
    activeInd: yup.string().required("Missing."),
};

export const commonMovementPatternDtlValidation: { [x: string]: any; } = {
    cntrStatus: yup.string().required("Missing."),
    movementCode: yup.string().required("Missing."),
    fromOtChargeInd: yup.string().required("Missing."),
    toOtChargeInd: yup.string().required("Missing."),
};

export const createMovementPatternValidation: { [x: string]: any; } = {
    ...commonMovementPatternValidation,
};
export const createMovementPatternDtlValidation: { [x: string]: any; } = {
    ...commonMovementPatternDtlValidation,
};

export const createMovementPatternValidationSchema = yup.object().shape(createMovementPatternValidation);
export const createMovementPatternDtlValidationSchema = yup.object().shape(createMovementPatternDtlValidation);

